import React from "react";

const Subscription = () => {
  return <div style={{display: "flex", width: "100%", height: "1000px", flexDirection: "column", backgroundColor: "white", overflow: "hidden"}}>
<iframe width="100%" height="100%" src="https://app.termly.io/policy-viewer/policy.html?policyUUID=de8527d1-02c7-4c19-91cf-69ab55482463" /></div>;
};

export default Subscription;
